var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroOne({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 326,
    viewBox: "0 0 328 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.049 92.3092C322.696 13.5732 246.342 -13.7805 192.212 6.37909C137.644 26.7017 124.993 -6.98575 48.2609 2.63824C-29.4341 12.3845 10.0155 134.313 10.0155 134.313C10.0155 134.313 22.3754 240.339 37.0226 289.209C51.5917 337.817 191.027 320.231 224.947 318.781C258.673 317.34 287.977 320.124 317.319 266.753C346.608 213.479 305.431 170.784 314.049 92.3092Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0797 239.988C67.1931 240.243 76.3298 240.292 85.4897 240.135C85.6062 240.291 91.916 221.5 84.5243 209.766C69.8363 186.969 85.145 171.514 90.4637 161.698C98.567 147.973 98.461 131.55 83.5414 128.686C67.0518 125.185 68.8674 97.1992 76.2684 72.7515C80.7347 60.9783 71.8429 44.18 60.9586 38.7858C49.9042 32.9865 36.8712 38.5925 29.0206 62.2438C18.6569 89.4031 36.1981 109.961 41.32 125.394C46.365 140.543 27.0024 148.679 38.8475 163.4C48.7094 176.362 62.1744 186.803 54.3367 199.531C46.3837 212.076 45.7746 223.371 58.0797 239.988Z",
    fill: "url(#paint0_linear_6_376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1694 243.289L69.7036 243.218C69.7211 242.969 68.3305 200.771 60.6989 158.99C59.7998 152.22 58.7389 145.382 57.7129 138.769C54.9621 121.039 52.117 102.705 52.3557 84.9719C52.6166 65.1208 56.7905 47.929 65.1162 32.416L65.5297 32.6384C47.065 67.0454 52.4652 101.849 58.1822 138.697C59.2094 145.312 60.2703 152.152 61.1682 158.917C68.8569 201.023 70.2032 243.118 70.1694 243.289Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.143 104.566C45.1655 91.812 35.9593 74.0718 31.0156 64.541C28.9193 60.4951 27.2586 57.2991 27.0187 57.0511L27.1573 56.9184V56.6308C27.4123 56.6308 27.4391 56.6366 31.429 64.3244C36.3751 73.8494 45.5743 91.5792 53.5424 104.32L53.143 104.566Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8949 88.9432L52.4512 88.7896C59.9047 67.3818 74.9117 59.7616 78.5231 58.893C78.763 58.836 78.9132 58.8232 79.0192 58.9245L78.6931 59.2644C78.7242 59.2959 78.7655 59.3153 78.8096 59.3192C78.2844 59.3192 73.8437 60.9352 68.5844 65.342C63.7723 69.3704 57.1469 76.7345 52.8949 88.9432Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.334 186.259L64.8682 186.233C65.5378 174.175 70.5177 161.963 79.6691 149.936C84.4334 143.673 90.1505 137.723 96.6617 132.251C96.982 131.982 97.2592 131.749 97.3034 131.699L97.6633 132.003C97.6039 132.073 97.4374 132.214 96.9645 132.612C87.9272 140.204 66.7595 160.629 65.334 186.259Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0374 173.204C55.4547 154.24 33.5603 149.308 33.346 149.277L33.3797 149.044H33.3704L33.254 149.251L33.1375 148.995L33.3483 148.808C33.6185 148.808 55.8472 153.959 63.473 173.026L63.0374 173.204Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8538 236.394L69.388 236.33C70.1065 231.122 73.4932 222.639 85.5433 211.801C85.8205 211.552 86.0604 211.335 86.0988 211.289L86.2549 211.417L86.5286 211.425C86.5286 211.552 86.5286 211.552 85.8577 212.15C73.9136 222.894 70.5619 231.264 69.8538 236.394Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8278 226.328C67.8134 216.989 56.433 208.231 49.7389 203.842C49.5059 203.691 49.3604 203.594 49.308 203.554L49.5933 203.179C49.6422 203.217 49.7808 203.308 49.9962 203.448C56.7602 207.883 68.2607 216.747 69.296 226.277L68.8278 226.328Z",
    fill: "#BEB8F2"
  })))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5825 268.303C98.489 268.149 102.501 266.135 103.33 265.179C108.849 258.816 119.957 247.575 119.868 238.673C119.851 237.152 113.141 235.413 112.259 233.979C108.249 231.836 106.725 231.341 103.915 227.43C95.6194 215.888 116.771 195.984 93.6874 187.515C76.7797 181.312 61.9939 186.526 65.1267 159.971C68.2595 133.415 49.464 83.8425 20.4247 101.072C3.75933 110.959 19.061 134.407 9.94335 150.719C1.2799 166.219 7.38124 179.619 23.8021 189.964C40.2229 200.308 30.8491 207.201 25.2171 222.056C18.4508 239.901 46.1903 244.459 59.1768 245.471C69.6314 246.286 95.7103 255.415 96.5825 268.303Z",
    fill: "url(#paint1_linear_6_376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M111.316 252.691C83.6427 237.514 61.3662 214.277 46.8949 185.487C33.1305 158.102 26.5645 126.233 27.9119 93.3256L28.3452 93.3431C25.5047 162.767 56.5995 222.196 111.524 252.31L111.316 252.691Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1916 231.764C65.2711 225.782 38.0696 224.615 21.5532 229.164L21.4368 228.745C38.0265 224.177 65.3422 225.347 82.3348 231.355L82.1916 231.764Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.598 246.653C93.8935 239.99 90.8154 230.214 91.4501 217.6C91.916 208.402 94.3034 197.924 98.5542 186.46L98.9606 186.612C94.7227 198.031 92.3399 208.464 91.8799 217.621C91.2522 230.108 94.2871 239.772 100.901 246.345L100.598 246.653Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0944 181.527C33.3518 168.59 15.4251 164.412 2.45497 163.19L2.49573 162.759C15.5392 163.99 33.5789 168.195 45.4159 181.236L45.0944 181.527Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0684 143.381C31.5863 123.41 43.8658 106.449 51.2284 98.1167L51.5533 98.4031C44.2326 106.688 32.023 123.552 32.5016 143.37L32.0684 143.381Z",
    fill: "#FCFDFE"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M251.213 258.362C249.314 258.595 244.983 257.412 243.98 256.639C237.308 251.497 224.191 242.681 222.518 233.935C222.231 232.441 228.464 229.411 229.039 227.827C232.544 224.931 233.939 224.144 235.917 219.754C241.758 206.795 217.078 191.481 238.023 178.604C253.364 169.173 268.885 171.348 260.551 145.942C252.217 120.536 260.794 68.2225 292.675 79.3507C310.971 85.7368 300.626 111.754 312.797 125.934C324.364 139.408 321.04 153.751 307.003 167.15C292.967 180.548 303.517 185.442 311.984 198.884C322.157 215.033 295.872 225.001 283.345 228.574C273.262 231.439 249.512 245.558 251.213 258.362Z",
    fill: "url(#paint2_linear_6_376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.676 245.983C257.783 225.622 275.011 198.428 283.483 167.34C291.541 137.768 291.654 105.232 283.809 73.244L283.388 73.3477C299.938 140.832 281.25 205.245 233.395 245.651L233.676 245.983Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258.075 219.701C273.472 210.482 299.902 203.944 316.992 205.127L317.022 204.694C299.855 203.507 273.313 210.071 257.853 219.328L258.075 219.701Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.982 237.939C248.231 230.079 249.308 219.893 246.185 207.649C243.907 198.723 239.483 188.929 233.04 178.542L232.672 178.775C239.092 189.128 243.503 198.881 245.764 207.766C248.856 219.874 247.799 229.952 242.62 237.708L242.982 237.939Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.461 163.102C293.406 148.092 310.147 140.447 322.617 136.673L322.491 136.258C309.949 140.052 293.104 147.75 284.089 162.879L284.461 163.102Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.661 123.13C286.168 103.461 270.772 89.2716 261.902 82.5641L261.64 82.9134C270.46 89.5825 285.77 103.685 289.234 123.209L289.661 123.13Z",
    fill: "#FCFDFE"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M290.761 149.494C290.761 176.208 282.369 200.988 268.14 221.387C268.084 221.47 267.883 221.551 267.883 221.635C245.557 254.339 207.3 275.528 164.384 275.528C160.874 275.528 157.513 275.364 154.075 274.89C154.061 274.89 154.054 275.099 154.04 275.099C152.348 274.959 150.67 274.894 148.999 274.688C148.405 274.618 147.811 274.593 147.219 274.509C146.695 274.44 146.171 274.393 145.653 274.313C145.199 274.246 144.748 274.189 144.301 274.116C144.198 274.098 144.097 274.088 143.996 274.074C142.895 273.892 141.797 273.704 140.702 273.492H140.685C82.3371 262.351 38.2478 211.071 38.2478 149.494C38.2478 136.474 40.1402 123.914 43.8041 112.096C44.377 110.244 45.0921 108.412 45.5661 106.598C46.9916 103.571 47.9465 100.607 49.2579 97.6964C49.7854 96.5321 50.3689 95.3748 50.9256 94.2291C53.9945 87.956 57.5782 81.9479 61.6399 76.2665C62.0068 75.7531 62.3876 75.2431 62.7614 74.732C64.2575 72.6976 65.8165 70.7113 67.4384 68.7732C69.8608 65.8648 72.4089 63.0705 75.0829 60.3903C82.0545 53.39 89.8207 47.2283 98.2234 42.0307C100.827 40.4193 103.495 38.9023 106.227 37.4795C124.228 28.0926 144.236 23.2068 164.539 23.2403C194.603 23.2403 222.211 33.7398 243.895 51.2716C259.85 64.1684 272.815 80.8654 280.976 99.9877C282.801 104.259 284.034 108.649 285.935 113.144C285.935 113.165 285.717 113.179 285.724 113.2C289.17 124.695 290.761 136.878 290.761 149.494Z",
    fill: "url(#paint3_linear_6_376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M192.051 192.057C189.341 195.875 180.958 200.774 186.646 210.4C192.285 220.001 186.254 221.801 182.374 220.903C178.475 220.015 166.357 219.519 168.378 225.024C170.398 230.529 173.864 232.602 169.426 234.73C164.988 236.859 163.111 242.381 158.571 249.998C154.06 257.627 143.341 251.028 146.516 258.676C149.691 266.325 152.155 265.586 151.858 270.916C151.788 272.381 152.759 273.884 154.071 275.313C152.378 275.173 150.679 275.002 148.994 274.796C148.4 274.726 147.807 274.648 147.215 274.563C146.691 274.493 146.167 274.42 145.648 274.339C145.194 274.273 144.743 274.203 144.296 274.13C144.194 274.112 144.22 274.095 144.119 274.081C143.035 273.899 142.472 273.703 141.048 273.499C140.098 272.598 140.693 271.619 140.836 270.564C142.252 260.721 128.668 253.957 126.395 247.061C124.158 240.183 126.367 236.08 125.849 230.378C125.331 224.677 127.174 217.139 123.902 212.344C120.627 207.57 107.42 205.964 104.907 196.322C102.375 186.699 108.262 172.289 110.548 169.834C112.808 167.381 99.614 156.212 93.3356 155.863C87.0282 155.479 89.5519 142.784 78.8888 144.717C68.2036 146.591 49.0098 140.632 52.9741 134.221C56.2466 128.94 61.7401 117.29 43.8076 112.1C44.3805 110.247 45.0886 108.416 45.5661 106.602C46.9916 103.575 47.9465 100.611 49.2579 97.6999C49.7854 96.5356 50.3689 95.3783 50.9256 94.2326C53.9967 87.9606 57.5803 81.9527 61.6399 76.27C62.0068 75.7566 62.3876 75.2466 62.7614 74.7355C64.2614 72.7011 65.8204 70.7148 67.4384 68.7767C69.8608 65.8683 72.409 63.074 75.0829 60.3938C82.0543 53.3922 89.8206 47.2294 98.2234 42.0307C101.775 44.5188 105.832 46.0533 109.335 44.1625C117.925 39.3563 112.262 38.6193 108.744 38.4412C107.827 38.3822 106.949 38.0469 106.227 37.4795C112.88 34.006 119.833 31.1388 127.002 28.9127C126.466 33.7608 119.876 41.5475 124.725 40.5975C130.368 39.524 132.672 24.2812 136.815 29.3458C141.018 34.4314 132.218 41.0969 140.482 37.235C148.758 33.4115 149.863 24.8761 159.085 29.028C168.353 33.2334 167.508 38.2095 170.094 37.717C172.681 37.2245 181.007 42.8306 175.965 47.4376C170.878 52.0575 166.214 46.1721 158.589 44.3965C150.96 42.6419 151.145 48.8814 147.635 50.3064C144.066 51.6838 126.847 43.365 122.621 50.8886C118.349 58.347 116.531 63.5514 122.872 63.3592C129.213 63.1671 129.616 61.5418 129.12 66.2257C128.624 70.9096 129.767 74.4211 135.507 70.0143C141.247 65.6075 139.948 61.3218 144.423 63.4186C148.899 65.5155 149.431 63.6177 154.191 60.1586C158.95 56.6995 165.211 56.3421 166.851 64.0974C168.491 71.8527 165.686 73.598 157.316 73.9938C148.946 74.3897 148 71.7607 145.328 78.7581C142.656 85.7554 131.6 94.7437 121.876 98.4485C112.153 102.153 108.367 107.646 108.591 115.044C108.814 122.442 105.171 130.277 102.735 124.166C100.299 118.056 93.4276 107.722 86.4307 114.619C79.4338 121.516 67.2148 133.745 80.7009 135.978C94.1613 138.253 87.1365 125.646 93.9401 128.166C100.733 130.704 89.631 136.261 94.173 138.267C98.7207 140.291 100.626 139.344 100.591 145.54C100.556 151.737 102.098 157.749 107.618 155.121C113.138 152.493 120.209 143.232 128.191 150.414C136.173 157.597 135.63 153.807 139.822 151.71C144.013 149.613 146.678 155.893 148.394 158.753C150.111 161.612 156.845 158.693 162.302 167.201C167.759 175.708 169.895 177.225 176.115 174.163C182.335 171.101 184.87 173.376 186.492 177.672C188.114 181.969 191.939 177.77 193.785 183.446C195.631 189.122 194.743 188.237 192.051 192.057Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.355 88.9875C208.947 79.5288 230.79 80.5918 234.65 81.3183C238.534 81.9657 247.645 74.8461 248.803 71.5383C249.992 68.2038 251.947 69.7919 258.854 69.693C265.763 69.6196 259.658 68.0571 252.054 65.5504C244.451 63.0437 250.952 62.8004 243.957 57.277C240.946 54.8588 241.894 52.8038 243.901 51.2763C259.977 64.2657 272.629 80.9909 280.753 99.9923C280.543 99.9237 280.324 99.8845 280.104 99.8759C275.265 99.8479 274.199 89.1528 271.706 87.0687C269.248 84.9882 271.776 92.9437 272.378 96.2119C272.98 99.48 271.052 96.7323 268.639 99.735C266.226 102.738 261.843 102.797 261.448 98.2878C261.053 93.7785 257.869 89.3752 251.437 87.3214C245.005 85.2676 239.432 86.9546 234.201 88.9712C228.995 90.9516 217.789 98.3716 213.355 88.9875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M268.19 221.633C268.626 218.386 269.34 215.032 267.984 213.805C264.687 210.746 263.967 202.413 265.109 198.192C266.252 193.97 275.133 194.201 269.106 187.171C263.061 180.121 257.614 171.754 260.152 166.969C262.689 162.184 261.921 161.846 257.163 161.869C252.406 161.893 250.311 162.102 245.566 157.871C240.818 153.579 234.288 168.001 216.419 156.435C198.554 144.753 208.732 125.065 215.423 125.016C222.159 124.9 230.029 121.504 224.507 113.29C219.004 105.044 227.605 103.88 231.806 105.753C236.016 107.606 243.48 102.629 251.088 100.385C258.716 98.1493 258.379 110.57 262.617 113.052C266.875 115.54 274.854 113.566 278.999 109.588C281.961 106.75 282.61 110.06 285.534 113.198C289.058 124.974 290.841 137.202 290.827 149.494C290.827 176.315 282.461 201.189 268.19 221.633Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M236.23 73.2452C236.23 73.237 241.801 70.7245 239.784 66.6763C237.784 62.6281 234.612 50.218 232.296 54.1288C229.979 58.0396 233.401 65.6843 232.645 68.9746C231.889 72.2649 231.872 74.0031 236.23 73.2452Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M230.671 69.4566C230.592 68.1526 231.414 62.8539 227.244 63.0204C227.252 63.0123 221.212 65.5318 224.745 69.8117C228.279 74.0916 230.762 70.7583 230.671 69.4566Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M290.425 149.272C290.425 175.985 282.201 200.767 267.972 221.164C267.918 221.237 267.887 221.323 267.883 221.413C245.082 254.118 207.132 275.203 164.217 275.203C160.71 275.195 157.208 274.947 153.735 274.461C153.721 274.461 153.714 274.773 153.7 274.773C152.008 274.633 150.33 274.617 148.659 274.41C148.065 274.341 147.47 274.342 146.879 274.258C146.355 274.188 145.831 274.154 145.313 274.074C144.859 274.008 144.408 273.958 143.96 273.887C143.858 273.868 143.757 273.86 143.656 273.846C142.555 273.664 141.457 273.477 140.362 273.264H140.345C86.3888 262.96 44.6309 218.3 38.6484 162.946C51.3018 199.23 82.5887 226.493 121.053 234.091H121.067C122.012 234.566 122.958 234.471 123.91 234.628C123.997 234.638 124.088 234.669 124.175 234.683C124.56 234.746 124.951 234.81 125.34 234.866C125.787 234.935 126.238 234.992 126.692 235.052C127.203 235.125 127.713 235.168 128.227 235.229C129.671 235.407 131.119 235.735 132.58 235.854C132.594 235.854 132.601 235.991 132.612 235.991C135.579 235.991 138.537 236.224 141.569 236.224C160.099 236.224 177.562 231.516 192.84 223.389C208.081 215.263 221.163 203.62 231.001 189.426C231.001 189.352 231.117 189.253 231.165 189.18C243.454 171.568 250.645 150.153 250.645 127.084C250.658 116.475 249.12 105.921 246.08 95.7567C246.08 95.7392 246.037 95.7182 246.037 95.7008C245.086 91.8214 243.556 88.0293 241.983 84.3408C235.91 70.1126 226.883 57.3365 215.499 46.859C204.115 36.3815 190.635 28.4415 175.95 23.5651C201.436 25.9112 224.732 35.8332 243.558 51.0551C259.513 63.953 272.41 80.6489 280.571 99.7711C282.395 104.043 283.559 108.432 285.462 112.928C285.462 112.949 285.314 112.962 285.321 112.983C288.766 124.477 290.425 136.658 290.425 149.272Z",
    fill: "url(#paint4_linear_6_376)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.284 182.818H66.0991V299.084H113.284V182.818Z",
    fill: "url(#paint5_linear_6_376)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 193.858H69.6791V201.14H109.705V193.858Z",
    fill: "#97A6B7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 206.776H69.6791V214.057H109.705V206.776Z",
    fill: "#97A6B7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 219.695H69.6791V226.976H109.705V219.695Z",
    fill: "#97A6B7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 232.613H69.6791V239.894H109.705V232.613Z",
    fill: "#97A6B7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 245.532H69.6791V252.813H109.705V245.532Z",
    fill: "#97A6B7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 258.449H69.6791V265.731H109.705V258.449Z",
    fill: "#97A6B7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 271.368H69.6791V278.65H109.705V271.368Z",
    fill: "#97A6B7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0992 182.818V299.084H53.4085V193.858L65.7311 183.137L66.0468 182.863L66.0992 182.818Z",
    fill: "#97A6B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3134 272.777H49.5036V274.421H57.3134V272.777Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 193.858H69.6791V195.267H109.705V193.858Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 206.776H69.6791V208.185H109.705V206.776Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 219.695H69.6791V221.104H109.705V219.695Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 232.613H69.6791V234.021H109.705V232.613Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 245.532H69.6791V246.94H109.705V245.532Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 258.449H69.6791V259.858H109.705V258.449Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 271.368H69.6791V272.777H109.705V271.368Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M111.718 299.084H66.0991L53.405 295.561V273.038C53.9046 271.634 54.4392 270.299 55.0122 269.071C60.36 257.59 58.6224 252.922 59.7393 244.521C60.8433 236.228 58.4338 191.739 65.7276 183.137C65.8243 183.021 65.9198 182.92 66.0188 182.818L66.0432 182.863L66.0956 182.957C68.9745 188.181 70.5991 191.194 71.532 193.858C71.6997 194.334 71.8441 194.802 71.9676 195.267C72.4462 197.036 72.65 198.797 72.7548 201.138C72.8235 202.701 72.8515 204.522 72.8853 206.776C72.8923 207.226 72.9 207.696 72.9086 208.186C72.9086 208.468 72.9179 208.756 72.9225 209.05C72.954 210.769 72.9761 212.441 73.0087 214.056C73.0483 216.025 73.1019 217.911 73.1974 219.694C73.2246 220.17 73.2541 220.639 73.2859 221.103C73.4373 223.238 73.6679 225.207 74.037 226.975C74.5029 229.197 75.1749 231.097 76.1834 232.611C76.5164 233.119 76.9004 233.592 77.3294 234.021C78.3198 235.006 79.5409 235.726 80.8814 236.117C82.6912 236.667 84.4544 237.98 86.0976 239.892C87.4113 241.416 88.6458 243.323 89.7673 245.529C90.0002 245.984 90.2261 246.461 90.4474 246.938C91.3205 248.848 92.0735 250.81 92.7021 252.813C93.2681 254.605 93.7665 256.493 94.1858 258.449C94.2871 258.915 94.3814 259.381 94.4723 259.859C94.838 261.764 95.1291 263.729 95.3341 265.731C95.5262 267.584 95.6473 269.468 95.6834 271.368C95.6928 271.834 95.6974 272.304 95.6974 272.777C95.6974 273.066 95.6974 273.359 95.6916 273.647C95.6556 275.326 95.7985 277.004 96.1179 278.653C98.4727 290.408 109.829 291.329 111.718 299.084Z",
    fill: "#97A6B7"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1635 202.076L29.8056 297.248L14.7333 294.364V211.113L26.9465 202.894L28.0086 202.178L28.1635 202.076Z",
    fill: "#97A6B7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4912 201.981H28.1635V297.248H65.4912V201.981Z",
    fill: "#F4F7FA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0133 212.503H35.2734V290.991H40.0133V212.503Z",
    fill: "#97A6B7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0859 212.503H45.148V290.991H50.0859V212.503Z",
    fill: "#97A6B7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9605 212.503H55.0226V290.991H59.9605V212.503Z",
    fill: "#97A6B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0133 212.503H38.4329V290.991H40.0133V212.503Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0859 212.503H48.5056V290.991H50.0859V212.503Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1585 212.503H58.5782V290.991H60.1585V212.503Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4901 297.242V297.248L28.1635 294.697L14.7333 294.364V284.681C20.9546 273.898 18.9061 269.413 20.2489 261.414C21.5602 253.605 18.7943 212.458 26.9465 202.894C27.2266 202.56 27.5386 202.255 27.8782 201.981L28.0144 202.178C28.0657 202.252 28.1169 202.326 28.1693 202.399C32.4108 208.511 34.3545 211.428 35.2734 214.531C36.1736 217.558 36.1061 220.751 36.2528 227.249C36.4345 235.239 36.3972 242.192 38.4329 246.979C38.8348 247.954 39.3664 248.87 40.0133 249.703C41.2431 251.27 42.9027 252.433 45.148 253.112C45.3972 253.189 45.6511 253.26 45.9143 253.323C46.8135 253.545 47.6833 253.872 48.5055 254.299C49.0523 254.577 49.5802 254.89 50.0859 255.237C51.8328 256.416 53.4947 258.038 55.0226 260.011C56.3842 261.788 57.5751 263.689 58.5793 265.69C59.0669 266.651 59.5277 267.651 59.9617 268.689C60.0293 268.849 60.0933 269.008 60.1585 269.17C62.5762 275.153 64.0099 282.248 63.8852 289.472C63.827 292.613 64.4431 295.146 65.4901 297.242Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3538 260.964H44.242V261.678H56.3538V260.964Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3538 269.839H44.242V270.553H56.3538V269.839Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3538 278.715H44.242V279.429H56.3538V278.715Z",
    fill: "#97A6B7"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8972 256.138V299.084L12.6173 295.752V260.216L31.8972 256.138Z",
    fill: "#97A6B7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2106 256.239H31.8972V299.084H92.2106V256.239Z",
    fill: "#F4F7FA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 261.34H42.7734V268.073H54.6383V261.34Z",
    fill: "#97A6B7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2001 261.34H59.0883V268.073H71.2001V261.34Z",
    fill: "#97A6B7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M87.515 261.34H75.65V268.073H87.515V261.34Z",
    fill: "#97A6B7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 270.216H42.7734V276.949H54.6383V270.216Z",
    fill: "#97A6B7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2001 270.216H59.0883V276.949H71.2001V270.216Z",
    fill: "#97A6B7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M87.515 270.216H75.65V276.949H87.515V270.216Z",
    fill: "#97A6B7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 279.09H42.7734V285.823H54.6383V279.09Z",
    fill: "#97A6B7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2001 279.09H59.0883V285.823H71.2001V279.09Z",
    fill: "#97A6B7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M87.515 279.09H75.65V285.823H87.515V279.09Z",
    fill: "#97A6B7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 287.965H42.7734V294.698H54.6383V287.965Z",
    fill: "#97A6B7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2001 287.965H59.0883V294.698H71.2001V287.965Z",
    fill: "#97A6B7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M87.515 287.965H75.65V294.698H87.515V287.965Z",
    fill: "#97A6B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 261.34H42.7734V262.054H54.6383V261.34Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 270.216H42.7734V270.929H54.6383V270.216Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 279.09H42.7734V279.803H54.6383V279.09Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6383 287.965H42.7734V288.679H54.6383V287.965Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2118 298.373V299.084H31.8972L12.6173 295.752V291.421C14.0007 289.954 15.581 288.687 17.3129 287.654C24.4007 283.472 22.0878 281.771 23.575 278.711C25.0622 275.652 21.7629 259.058 31.8972 256.235C41.3724 260.962 40.7144 260.757 41.044 265.79C41.2187 268.482 41.207 270.863 42.7734 272.631C44.1336 274.167 46.6864 275.239 51.5906 275.65C52.6212 275.738 53.6403 275.875 54.6383 276.06C57.6878 276.609 60.6329 277.63 63.367 279.087C66.7094 280.898 69.2727 283.259 70.471 285.82C70.794 286.499 71.0172 287.22 71.1337 287.963C71.1707 288.203 71.1945 288.446 71.2047 288.689C71.2152 288.9 71.2152 289.111 71.2047 289.323C71.2001 289.396 71.2001 289.469 71.2047 289.543C71.2525 291.373 73.0809 292.635 75.6547 293.603C76.8318 294.032 78.0316 294.396 79.2486 294.695C84.3577 295.997 90.3554 296.776 92.2118 298.373Z",
    fill: "#97A6B7"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M288.829 225.076V297.933L278.574 295.725V231.996L287.901 225.704L288.711 225.155L288.829 225.076Z",
    fill: "#97A6B7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M317.33 225.005H288.829V297.933H317.33V225.005Z",
    fill: "#F4F7FA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M297.878 233.06H294.258V293.143H297.878V233.06Z",
    fill: "#97A6B7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M305.568 233.06H301.798V293.143H305.568V233.06Z",
    fill: "#97A6B7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M313.108 233.06H309.338V293.143H313.108V233.06Z",
    fill: "#97A6B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M297.878 233.06H296.671V293.143H297.878V233.06Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M305.569 233.06H304.362V293.143H305.569V233.06Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M313.259 233.06H312.052V293.143H313.259V233.06Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M317.331 297.928H288.829L278.572 295.729V288.312C283.323 280.057 281.758 276.624 282.784 270.498C283.786 264.52 281.672 233.022 287.898 225.701C288.11 225.446 288.347 225.212 288.605 225.003L288.709 225.153C288.748 225.209 288.788 225.269 288.825 225.323C292.065 230.001 293.549 232.234 294.255 234.609C294.942 236.923 294.89 239.37 295.002 244.344C295.141 250.462 295.113 255.784 296.668 259.448C296.974 260.194 297.38 260.896 297.874 261.533C298.813 262.733 300.08 263.623 301.794 264.144C301.984 264.202 302.179 264.26 302.377 264.305C303.064 264.475 303.728 264.726 304.356 265.052C304.774 265.265 305.177 265.505 305.563 265.77C306.894 266.674 308.165 267.914 309.333 269.423C310.372 270.782 311.281 272.237 312.046 273.768C312.419 274.504 312.771 275.269 313.102 276.065C313.154 276.181 313.204 276.308 313.253 276.433C315.216 281.375 316.183 286.657 316.098 291.974C316.061 294.384 316.531 296.321 317.331 297.928Z",
    fill: "#97A6B7"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M284.983 190.174H241.251V297.933H284.983V190.174Z",
    fill: "url(#paint6_linear_6_376)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 200.405H244.569V207.153H281.666V200.405Z",
    fill: "#97A6B7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 212.379H244.569V219.127H281.666V212.379Z",
    fill: "#97A6B7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 224.352H244.569V231.1H281.666V224.352Z",
    fill: "#97A6B7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 236.324H244.569V243.073H281.666V236.324Z",
    fill: "#97A6B7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 248.298H244.569V255.046H281.666V248.298Z",
    fill: "#97A6B7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 260.271H244.569V267.02H281.666V260.271Z",
    fill: "#97A6B7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 272.244H244.569V278.992H281.666V272.244Z",
    fill: "#97A6B7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M241.251 190.174V297.933H229.489V200.405L240.91 190.47L241.204 190.215L241.251 190.174Z",
    fill: "#97A6B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 216.733H225.869V218.257H233.107V216.733Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 235.671H225.869V237.195H233.107V235.671Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 254.611H225.869V256.135H233.107V254.611Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 273.55H225.869V275.074H233.107V273.55Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 200.405H244.569V201.711H281.666V200.405Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 212.379H244.569V213.685H281.666V212.379Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 224.352H244.569V225.658H281.666V224.352Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 236.324H244.569V237.631H281.666V236.324Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 248.298H244.569V249.604H281.666V248.298Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 260.271H244.569V261.578H281.666V260.271Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 272.244H244.569V273.55H281.666V272.244Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M283.531 297.933H241.256L229.494 294.673V273.792C229.959 272.491 230.452 271.254 230.983 270.115C235.94 259.474 234.327 255.149 235.364 247.362C236.388 239.678 234.154 198.442 240.915 190.47C241.004 190.365 241.093 190.268 241.185 190.174C241.193 190.187 241.2 190.202 241.207 190.215L241.256 190.302C243.924 195.144 245.43 197.937 246.294 200.405C246.449 200.847 246.584 201.281 246.698 201.711C247.142 203.351 247.331 204.983 247.428 207.154C247.491 208.602 247.517 210.289 247.545 212.379C247.552 212.797 247.559 213.232 247.567 213.685C247.567 213.946 247.575 214.213 247.58 214.486C247.609 216.08 247.63 217.629 247.66 219.127C247.696 220.951 247.746 222.7 247.835 224.352C247.86 224.793 247.887 225.228 247.916 225.658C248.028 227.486 248.261 229.304 248.615 231.1C249.043 233.16 249.669 234.92 250.604 236.324C250.914 236.795 251.271 237.233 251.67 237.631C252.588 238.543 253.72 239.212 254.962 239.575C256.639 240.085 258.273 241.302 259.796 243.074C261.013 244.486 262.158 246.253 263.197 248.298C263.411 248.721 263.622 249.158 263.827 249.604C264.635 251.373 265.331 253.19 265.911 255.046C266.435 256.708 266.896 258.457 267.286 260.271C267.379 260.702 267.467 261.138 267.55 261.578C267.89 263.343 268.161 265.165 268.35 267.02C268.527 268.737 268.639 270.483 268.674 272.244C268.683 272.678 268.688 273.114 268.688 273.55C268.688 273.818 268.688 274.086 268.688 274.356C268.655 275.911 268.787 277.466 269.083 278.993C271.256 289.891 281.781 290.744 283.531 297.933Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M214.098 216.584H206.708V218.108H214.098V216.584Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M214.098 235.523H206.708V237.047H214.098V235.523Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M214.098 254.463H206.708V255.987H214.098V254.463Z",
    fill: "#97A6B7"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M199.178 206.283V297.933L187.415 295.155V214.984L199.178 206.283Z",
    fill: "#97A6B7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M235.973 206.501H199.178V297.933H235.973V206.501Z",
    fill: "#F4F7FA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 217.386H205.813V231.753H213.051V217.386Z",
    fill: "#97A6B7"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M223.155 217.386H215.765V231.753H223.155V217.386Z",
    fill: "#97A6B7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 217.386H225.869V231.753H233.107V217.386Z",
    fill: "#97A6B7"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 236.324H205.813V250.692H213.051V236.324Z",
    fill: "#97A6B7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M223.155 236.324H215.765V250.692H223.155V236.324Z",
    fill: "#97A6B7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 236.324H225.869V250.692H233.107V236.324Z",
    fill: "#97A6B7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 255.264H205.813V269.631H213.051V255.264Z",
    fill: "#97A6B7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M223.155 255.264H215.765V269.631H223.155V255.264Z",
    fill: "#97A6B7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 255.264H225.869V269.631H233.107V255.264Z",
    fill: "#97A6B7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 274.203H205.813V288.571H213.051V274.203Z",
    fill: "#97A6B7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M223.155 274.203H215.765V288.571H223.155V274.203Z",
    fill: "#97A6B7"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 274.203H225.869V288.571H233.107V274.203Z",
    fill: "#97A6B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 217.386H205.813V218.91H213.051V217.386Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 236.324H205.813V237.848H213.051V236.324Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 255.264H205.813V256.788H213.051V255.264Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 274.203H205.813V275.727H213.051V274.203Z",
    fill: "#97A6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M235.973 296.414V297.928H199.172L187.41 295.15V281.587C188.197 278.695 189.146 275.882 190.275 273.554C194.598 264.628 193.186 260.999 194.094 254.469C195.003 247.938 192.989 212.528 199.172 206.5C204.952 216.585 204.551 216.15 204.752 226.891C204.859 232.636 204.851 237.719 205.807 241.489C206.636 244.768 208.194 247.056 211.186 247.933C211.846 248.133 212.474 248.427 213.049 248.807C214.994 250.058 216.824 252.319 218.374 255.263C220.413 259.127 221.976 264.165 222.705 269.631C222.905 271.126 223.043 272.658 223.109 274.202C223.131 274.716 223.146 275.235 223.152 275.753C223.159 276.203 223.159 276.654 223.152 277.105C223.152 277.263 223.152 277.42 223.152 277.57C223.181 281.475 224.297 284.168 225.867 286.234C226.52 287.08 227.255 287.859 228.06 288.562C231.182 291.345 234.84 293.019 235.973 296.414Z",
    fill: "#97A6B7"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8263 199.78C84.2634 198.452 87.0119 196.921 88.3907 193.363C88.8065 192.292 90.2762 188.497 88.1077 185.593C86.8197 183.87 84.4288 182.7 82.3209 183.114C80.5204 183.463 80.2386 184.722 77.178 187.246C75.9866 188.229 74.0708 189.808 71.9373 190.686C68.2863 192.19 66.0933 190.775 62.4272 190.936C57.9237 191.135 52.6923 193.647 50.1721 197.301C45.6977 203.786 52.1787 210.364 47.2781 217.961C45.6733 220.451 44.8813 219.893 41.0789 224.714C37.2765 229.535 35.3666 231.95 35.7054 234.906C36.1713 239.009 40.5968 242.928 44.7579 243.195C48.8235 243.454 51.4077 240.257 53.4784 241.656C54.9516 242.651 54.1096 244.587 55.6737 246.915C57.6907 249.914 61.655 250.512 62.2956 250.609C68.235 251.504 76.2521 244.538 79.6551 236.288C85.7948 221.396 75.0142 207 82.8263 199.78Z",
    fill: "url(#paint7_linear_6_376)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1693 277.064C36.6476 276.397 35.4783 276.148 34.6375 276.403C32.9873 276.901 33.0012 280.106 32.6111 283.528C32.1697 287.412 31.535 291.531 33.2738 291.512C34.0482 291.502 35.4481 289.143 35.7276 286.956C35.9613 285.229 36.3991 283.536 37.0319 281.912C37.2132 281.205 37.3378 280.485 37.4046 279.758C37.5304 278.395 37.6026 277.62 37.1693 277.064Z",
    fill: "url(#paint8_linear_6_376)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0463 279.849C35.0463 281.527 37.8739 282.204 39.5882 282.204C41.3025 282.204 41.2443 281.527 41.2443 279.849C41.2443 278.171 41.1814 276.947 39.4718 276.947C37.7621 276.947 35.0463 278.171 35.0463 279.849Z",
    fill: "url(#paint9_linear_6_376)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M109.578 309.234C110.51 312.913 111.439 316.593 112.364 320.272C112.149 320.641 111.614 321.424 110.699 321.593C109.674 321.781 108.782 321.086 108.449 320.796C107.725 315.585 106.459 312.296 105.217 310.13C104.346 308.61 103.49 307.656 103.556 307.113C103.675 306.129 106.683 307.596 109.578 309.234Z",
    fill: "url(#paint10_linear_6_376)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8655 239.843C95.8814 248.566 99.1248 261.537 103.327 276.226C107.1 289.418 110.382 301.229 112.04 310.474C111.137 311.218 110.165 311.873 109.137 312.43C104.828 314.765 100.549 314.793 98.1629 314.598C97.9525 311.15 97.5396 307.716 96.9261 304.316C95.8349 298.262 93.8981 287.024 89.2572 276.839C86.0417 269.775 84.4334 266.244 81.7176 263.829C80.0475 262.346 76.1776 259.205 75.5126 254.421C75.4858 254.221 75.4734 254.019 75.4753 253.818C75.4975 247.128 87.9202 241.174 90.8655 239.843Z",
    fill: "#444B8C"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.22,
    d: "M90.8655 239.843C93.6058 244.608 95.8174 250.651 97.9451 257.54C92.9303 260.228 88.6493 264.725 90.6081 270.209C92.4773 275.816 99.4882 278.153 100.89 284.695C102.288 291.704 99.0212 297.778 100.425 304.788C101.116 308.071 101.356 311.356 101.487 314.616C100.38 314.694 99.2695 314.688 98.1641 314.597C97.9537 311.148 97.5407 307.715 96.9272 304.315C95.836 298.261 93.8993 287.023 89.2584 276.838C86.0429 269.774 84.4346 266.243 81.7187 263.828C80.0487 262.345 76.1787 259.204 75.5138 254.42C75.487 254.22 75.4745 254.018 75.4765 253.817C75.4975 247.128 87.9202 241.174 90.8655 239.843Z",
    fill: "url(#paint11_linear_6_376)"
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1803 252.169C86.2767 252.401 86.333 252.647 86.3469 252.897C86.4435 255.378 81.8573 258.627 71.8872 274.527C70.1263 277.335 67.1228 282.251 62.2595 283.708C61.7485 283.862 61.2258 283.974 60.6966 284.043C59.7682 284.164 58.8274 284.155 57.9015 284.016C56.695 283.845 52.0203 284.016 38.7031 285.207C38.5971 284.974 36.325 279.689 39.2342 276.037C39.9436 275.163 40.8531 274.472 41.886 274.023C45.0106 273.557 47.6321 273.311 49.6119 273.179C52.0122 273.018 53.5366 273.012 55.2101 273.161C56.3747 273.264 57.3309 273.417 58.0052 273.542C62.7719 259.817 60.4427 247.896 66.1609 247.644C67.3045 247.591 85.0157 248.711 86.1803 252.169Z",
    fill: "url(#paint12_linear_6_376)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M118.419 316.938C118.06 316.438 115.697 316.693 114.505 317.348C112.504 318.447 111.337 320.408 110.824 320.677C109.66 321.29 108.549 320.765 108.449 320.793C108.449 320.793 107.67 322.371 109.072 323.13C110.474 323.889 120.64 320.034 118.419 316.938Z",
    fill: "#444B8C"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93 171.289C118.163 171.314 117.984 173.069 118.405 173.143C118.671 173.191 119.02 172.535 119.166 172.192C119.654 171.052 119.261 170.236 119.88 169.671C119.972 169.586 120.145 169.43 120.261 169.482C120.621 169.641 120.145 171.683 119.885 172.646C120.144 171.866 120.708 170.391 121.307 169.909C121.388 169.844 121.63 169.649 121.736 169.719C121.842 169.789 121.776 170.025 121.724 170.213C121.419 171.294 120.423 172.959 120.502 173.027C120.581 173.094 122.249 171.009 122.544 171.193C122.803 171.353 122.007 173.203 120.88 174.713C120.423 175.324 119.948 175.94 119.43 176.226L119.861 177.663H117.931V175.958C117.826 175.854 117.73 175.741 117.644 175.621C116.46 173.995 117.637 171.256 117.93 171.289Z",
    fill: "url(#paint13_linear_6_376)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M120.652 176.996L116.926 176.234C116.727 178.499 115.951 183.569 112.131 188.227C108.255 192.958 102.079 196.26 95.8861 196.152C90.8387 196.065 89.0557 193.772 87.4393 194.988C83.9303 197.614 86.4051 212.841 95.107 216.426C103.395 219.839 113.23 211 117.46 204.862C125.597 193.051 121.338 179.121 120.652 176.996Z",
    fill: "url(#paint14_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M106.286 209.145C108.732 207.072 107.495 204.089 111.095 199.142C114.714 194.164 117.974 194.43 120.581 190.436C121.415 189.146 122.005 187.713 122.32 186.209C122.619 191.61 121.817 198.537 117.463 204.858C113.233 210.996 103.398 219.836 95.1093 216.422C90.8003 214.645 88.0134 210.008 86.73 205.463C98.8453 211.729 103.938 211.133 106.286 209.145Z",
    fill: "url(#paint15_linear_6_376)"
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M100.194 198.791C99.8155 198.202 98.6101 196.571 93.4928 195.368C90.9307 194.765 86.1873 193.738 80.086 195.019C71.7067 196.795 66.4881 201.821 64.5234 203.934C66.1318 204.982 70.5712 208.175 72.7688 214.237C73.4524 216.123 75.473 222.569 72.5836 228.607C70.9183 232.088 67.973 234.699 65.737 236.683C62.3806 239.659 60.643 240.116 59.518 242.783C58.294 245.686 59.5285 247.101 58.004 249.088C56.3736 251.224 54.4566 250.231 51.6872 252.389C48.8503 254.601 49.86 256.42 47.2781 258.864C43.5269 262.414 38.554 261.26 38.3235 262.857C38.1243 264.232 41.6577 266.096 44.6612 266.852C50.6065 268.349 55.7936 265.837 57.3355 265.061C61.6061 262.917 60.8689 261.529 64.124 259.894C69.5755 257.156 73.301 260.203 85.7168 260.516C92.4412 260.686 95.8407 260.724 97.704 258.45C99.4044 256.373 98.5099 254.094 97.4897 244.274C97.1613 240.994 96.4742 234.127 96.4707 230.214C96.4707 227.902 97.2696 224.124 98.8745 216.566C98.9688 216.121 99.8376 212.039 100.539 206.584C101.173 201.678 101.087 200.17 100.194 198.791Z",
    fill: "url(#paint16_linear_6_376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.2827 258.87C49.8646 256.425 48.8549 254.606 51.6919 252.395C54.4613 250.236 56.3748 251.231 58.0087 249.094C59.5308 247.107 58.2963 245.692 59.5227 242.788C60.6477 240.122 62.3852 239.665 65.7416 236.689C67.9776 234.71 70.9229 232.093 72.5883 228.613C75.4777 222.575 73.4571 216.129 72.7735 214.243C70.5759 208.181 66.1353 204.986 64.5281 203.94C64.683 203.773 64.8658 203.583 65.0615 203.383C75.6593 204.839 81.8317 210.96 82.6015 212.773C84.3682 216.965 81.5708 218.503 81.4986 230.587C81.4649 236.363 82.0879 238.644 80.2176 241.055C78.0736 243.812 75.6034 242.958 72.5033 246.564C70.1205 249.333 70.5013 251.09 68.277 252.256C65.886 253.512 64.3627 252.049 61.6644 252.624C57.1574 253.585 56.1907 258.78 53.214 261.623C50.9617 263.772 46.7959 265.274 38.5797 263.662C38.3898 263.386 38.2978 263.116 38.3351 262.862C38.5576 261.266 43.5292 262.419 47.2827 258.87Z",
    fill: "url(#paint17_linear_6_376)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5262 188.476C83.5262 188.476 82.9917 192.747 81.4148 193.727C79.8379 194.706 77.2886 195.983 77.0079 196.33C76.7273 196.677 86.7766 197.756 91.7564 195.244C90.1155 194.901 89.6695 194.778 89.6695 194.778C88.9348 194.588 88.2264 194.308 87.5604 193.944C86.6375 193.411 85.845 192.678 85.2405 191.8L85.2591 189.435L83.5262 188.476Z",
    fill: "url(#paint18_linear_6_376)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2863 189.989C83.2863 189.989 84.3147 191.4 85.9265 190.812C87.3706 190.285 86.5088 186.558 85.364 186.132C84.982 185.99 84.2797 186.053 83.8115 186.346C83.4808 186.551 82.6004 187.646 83.1058 188.87C82.7413 188.764 82.4199 188.861 82.3395 189.042C82.237 189.274 82.5468 189.583 82.6167 189.653C82.7993 189.832 83.0334 189.95 83.2863 189.989Z",
    fill: "url(#paint19_linear_6_376)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7595 215.791C75.7595 215.791 78.3426 213.523 80.0883 214.308C81.834 215.092 80.5274 217.011 79.4804 217.71C78.4334 218.408 78.7979 217.099 77.0021 217.71C75.2063 218.321 75.7595 215.791 75.7595 215.791Z",
    fill: "url(#paint20_linear_6_376)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5409 198.938C70.308 198.868 58.4547 206.196 57.5824 217.883C56.7102 229.57 74.8697 220.239 77.7416 217.883L77.0021 214.308C77.0021 214.308 70.669 215.588 68.6624 215.385C66.6558 215.181 74.6019 211.29 74.6019 211.29C74.6019 211.29 74.5146 200.141 70.5409 198.938Z",
    fill: "url(#paint21_linear_6_376)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M133.787 300.239C132.653 300.775 131.552 301.377 130.49 302.044C129.952 302.382 129.605 302.626 129.373 303.066C128.928 303.913 129.24 304.864 129.496 305.649C130.931 310.074 131.243 311.445 132.551 312.752C132.833 313.034 133.504 313.69 133.901 313.514C134.067 313.441 134.15 313.189 134.203 312.767C134.331 311.748 131.866 303.77 133.787 300.239Z",
    fill: "url(#paint22_linear_6_376)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M133.172 299.338L131.377 301.829C131.377 301.829 131.573 303.011 132.91 302.877L134.713 300.394L133.172 299.338Z",
    fill: "url(#paint23_linear_6_376)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M174.923 237.292C174.592 239.873 174.057 243.712 173.245 248.342C171.667 257.327 169.93 264.225 169.601 265.437C165.435 280.766 138.622 298.687 134.04 301.708L132.287 299.625C133.602 292.672 136.583 283.453 144.166 276.138C148.234 272.212 149.763 272.563 152.075 269.275C159.786 258.304 149.66 244.585 155.452 238.159C157.674 235.689 162.647 233.86 174.923 237.292Z",
    fill: "url(#paint24_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M159.783 235.785C160.941 242.57 161.028 249.495 160.04 256.307C158.597 266.141 157.088 276.426 149.578 281.047C145.798 283.375 142.492 283.037 139.189 287C136.314 290.449 136.985 292.903 134.463 296.3C133.895 297.068 133.247 297.774 132.531 298.406C132.444 298.821 132.363 299.229 132.286 299.63L134.038 301.713C138.623 298.686 165.434 280.771 169.599 265.442C169.929 264.23 171.665 257.332 173.243 248.347C174.059 243.716 174.591 239.878 174.922 237.297C167.601 235.245 162.88 235.069 159.783 235.785Z",
    fill: "url(#paint25_linear_6_376)"
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M192.228 244.906C192.228 244.906 191.296 247.334 192.655 248.968C194.014 250.603 195.217 252.559 196.087 252.518C196.957 252.478 196.8 251.032 196.111 249.999C195.423 248.966 193.464 246.099 193.433 245.435C193.401 244.771 192.228 244.906 192.228 244.906Z",
    fill: "url(#paint26_linear_6_376)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M176.767 184.202C180.378 189.184 183.253 194.659 185.306 200.459C187.569 206.887 186.191 206.336 188.853 216.096C191.88 227.216 194.927 232.531 194.623 242.316C194.579 243.736 194.475 244.9 194.39 245.658L190.64 246.706C186.702 244.028 184.971 241.218 184.118 239.169C182.273 234.734 183.922 232.384 181.942 225.444C180.777 221.369 179.219 218.712 178.875 218.137C176.387 213.982 173.791 212.199 172.576 210.824C169.863 207.737 168.957 200.846 176.767 184.202Z",
    fill: "url(#paint27_linear_6_376)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M169.902 317.689L173.242 323.547L175.171 322.493L173.161 316.539L169.902 317.689Z",
    fill: "url(#paint28_linear_6_376)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M172.85 323.395C172.85 323.395 173.341 325.739 173.992 325.991C174.643 326.242 180.698 321.279 180.747 320.692C180.796 320.105 174.924 321.966 174.583 322.061C174.241 322.157 172.676 322.702 172.85 323.395Z",
    fill: "url(#paint29_linear_6_376)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M147.07 234.244C145.826 237.298 144.382 241.92 144.417 247.54C144.488 259.101 150.741 262.443 154.403 276.784C157.314 288.167 154.34 289.856 157.456 299.638C160.521 309.259 166.087 316.085 170.225 320.295L174.407 318.388C166.53 292.499 162.576 265.577 162.676 238.518L147.07 234.244Z",
    fill: "url(#paint30_linear_6_376)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M125.346 246.829C125.346 246.829 122.865 246.898 121.425 250.744C121.802 250.827 122.65 251.12 122.65 251.12C122.65 251.12 123.364 248.221 125.133 248.157C125.106 247.78 125.346 246.829 125.346 246.829Z",
    fill: "url(#paint31_linear_6_376)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M133.666 249.115L132.842 251.204C131.829 250.543 130.729 249.799 129.443 249.331C127.908 248.773 126.299 248.447 124.668 248.362C124.597 248.123 124.58 247.871 124.617 247.625C124.671 247.23 124.823 246.854 125.057 246.531C125.886 246.481 126.718 246.505 127.543 246.602C130.023 246.893 132.019 247.97 133.666 249.115Z",
    fill: "url(#paint32_linear_6_376)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M133.58 249.765C133.655 249.506 133.736 249.183 133.663 249.115C133.591 249.048 133.42 249.256 133.336 249.373C133.219 249.55 133.128 249.744 133.065 249.947C132.934 250.258 132.849 250.587 132.811 250.922C132.803 251.027 132.791 251.184 132.84 251.204C132.889 251.224 132.942 251.136 133.05 250.971C133.284 250.597 133.463 250.191 133.58 249.765Z",
    fill: "url(#paint33_linear_6_376)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M134.247 254.901C133.753 254.851 132.536 254.784 132.536 254.784C132.536 254.784 134.043 252.504 133.002 250.921C133.034 250.624 133.113 250.333 133.235 250.061C133.331 249.844 133.455 249.64 133.603 249.454C134.087 249.984 135.011 251.566 134.247 254.901Z",
    fill: "url(#paint34_linear_6_376)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M143.679 258.512C143.679 258.512 144.028 257.178 142.082 256.583C141.704 256.73 141.358 257.801 141.358 257.801L143.679 258.512Z",
    fill: "url(#paint35_linear_6_376)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M137.473 284.917L131.094 286.764L131.778 273.037L142.32 257.581L143.679 258.512L138.438 283.742C138.325 284.319 137.937 284.784 137.473 284.917Z",
    fill: "url(#paint36_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M131.778 273.031L142.32 257.575L143.679 258.506C142.846 259.903 141.916 262.301 141.414 263.642C139.276 269.347 137.599 270.604 136.927 274.837C136.369 278.356 137.268 279.133 136.482 281.374C135.626 283.819 133.654 285.476 131.565 286.613L131.099 286.748L131.778 273.031Z",
    fill: "url(#paint37_linear_6_376)"
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M142.32 257.575L113.13 248.634L100.237 274.302L131.094 286.758L142.32 257.575Z",
    fill: "url(#paint38_linear_6_376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M113.13 248.634L122.963 251.646C122.978 252.468 123.042 253.288 123.154 254.102C124.655 264.899 134.357 269.174 133.699 270.671C132.717 272.91 111.308 262.748 109.758 265.762C109.01 267.218 112.669 272.166 117.211 275.009C122.649 278.41 127.613 277.743 129.416 282.195C130.026 283.703 130.025 285.25 129.942 286.27L100.237 274.306L113.13 248.634Z",
    fill: "url(#paint39_linear_6_376)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M142.081 256.583C142.411 256.684 142.883 256.781 143.286 257.25C143.368 257.345 143.441 257.447 143.504 257.555L143.3 257.396C142.966 257.163 142.408 257.163 142.094 257.512C141.71 257.932 141.279 259.045 141.052 259.594C140.415 261.154 136.458 270.865 136.458 270.865C136.132 271.686 135.344 272.146 134.649 271.913L107.963 262.074C107.752 262.004 107.571 261.866 107.448 261.681C107.32 261.468 107.25 261.225 107.243 260.977C107.236 260.728 107.294 260.482 107.41 260.262L112.43 248.792C112.755 248.143 113.405 247.805 113.983 247.982L142.081 256.583Z",
    fill: "url(#paint40_linear_6_376)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M141.792 256.492C142.121 256.592 142.526 256.663 142.922 256.923C143.05 256.999 143.164 257.097 143.257 257.213C143.257 257.213 142.408 256.694 141.805 257.415C141.437 257.857 140.99 258.949 140.757 259.497C140.12 261.057 136.164 270.769 136.164 270.769C135.839 271.591 135.05 272.049 134.354 271.816L107.091 262.77C106.88 262.7 106.699 262.562 106.577 262.376C106.449 262.164 106.378 261.921 106.371 261.673C106.364 261.424 106.421 261.178 106.538 260.958L112.14 248.691C112.466 248.044 113.115 247.705 113.694 247.883L141.792 256.492Z",
    fill: "url(#paint41_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M106.542 260.96L112.14 248.691C112.466 248.044 113.115 247.705 113.694 247.883L141.792 256.492C142.121 256.592 142.526 256.663 142.922 256.923C143.05 256.999 143.164 257.097 143.257 257.213C143.257 257.213 142.408 256.694 141.805 257.415C141.74 257.496 141.68 257.581 141.626 257.669C138.923 256.971 136.279 256.066 133.554 255.435C128.169 254.176 122.84 252.543 117.155 253.307C115.338 253.55 113.44 255.846 113.499 257.193C113.543 258.165 114.627 258.421 114.645 259.685C114.665 261.013 113.481 261.547 113.61 262.517C113.75 263.533 115.124 263.491 116.956 264.745C117.759 265.302 118.475 265.976 119.08 266.745L107.095 262.769C106.885 262.699 106.704 262.561 106.582 262.375C106.454 262.163 106.383 261.921 106.377 261.673C106.37 261.425 106.427 261.179 106.542 260.96Z",
    fill: "url(#paint42_linear_6_376)"
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M118.494 268.864L121.66 270.806L122.009 270.949C122.359 271.093 122.784 270.85 122.941 270.408L124.387 266.226C124.541 265.783 124.364 265.323 124 265.204L123.636 265.088L120.035 264.506C119.707 264.4 119.487 264.126 119.343 264.541L117.986 268.463C117.843 268.873 118.174 268.735 118.494 268.864Z",
    fill: "url(#paint43_linear_6_376)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M118.053 269.37L121.76 270.871C122.116 271.015 122.536 270.772 122.692 270.33L124.138 266.148C124.292 265.705 124.116 265.245 123.75 265.128L119.95 263.896C119.622 263.79 119.237 264.043 119.094 264.457L117.737 268.381C117.59 268.795 117.733 269.24 118.053 269.37Z",
    fill: "url(#paint44_linear_6_376)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M138.98 184.141C138.98 184.141 163.669 180.684 176.768 184.202C176.768 184.202 179.693 187.181 180.034 197.957C180.375 208.732 176.006 218.136 176.108 222.859C176.211 227.583 176.424 236.438 175.956 239.091L171.181 244.07L167.844 237.833L161.723 245.154L145.265 237.326C145.265 237.326 148.417 227.327 147.487 220.818C146.558 214.31 139.418 200.374 138.98 184.141Z",
    fill: "url(#paint45_linear_6_376)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M180.034 197.957C179.693 187.181 176.767 184.202 176.767 184.202C175.818 183.947 174.809 183.729 173.752 183.544L167.898 209.665L167.849 237.833L171.186 244.07L175.96 239.091C176.426 236.438 176.217 227.582 176.113 222.859C176.009 218.137 180.374 208.732 180.034 197.957Z",
    fill: "url(#paint46_linear_6_376)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M151.687 182.927C153.85 182.452 156.046 182.139 158.256 181.988C163.195 181.661 168.153 182.14 172.937 183.409C172.937 183.409 172.355 199.836 167.898 209.665C167.898 209.665 154.858 190.968 151.687 182.927Z",
    fill: "#EFEFEF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M162.351 177.523C162.351 177.523 162.679 182.213 160.284 182.405C160.284 182.405 164.445 184.22 167.186 182.784C167.186 182.784 164.54 181.691 164.802 177.544L162.351 177.523Z",
    fill: "url(#paint47_linear_6_376)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M164.857 185.499C164.857 185.499 164.756 195.321 164.974 198.539C165.191 201.757 165.687 206.433 166.069 207.567C166.451 208.701 167.898 211.126 167.898 211.126L169.617 207.085C169.617 207.085 168.389 191.159 165.835 185.429L164.857 185.499Z",
    fill: "url(#paint48_linear_6_376)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M163.393 182.863C163.393 182.863 165.292 182.104 166.072 182.921C166.274 183.133 166.538 185.614 166.04 186.167C165.526 186.751 163.708 186.519 163.393 182.863Z",
    fill: "url(#paint49_linear_6_376)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M149.92 183.044C149.92 183.044 150.835 182.626 152.61 182.794L167.898 209.665L167.89 214.223C167.89 214.223 167.688 211.22 164.813 209.177C161.937 207.133 159.653 202.045 159.349 199.979C159.045 197.912 155.208 195.513 153.052 194.706L149.92 183.044Z",
    fill: "url(#paint50_linear_6_376)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M172.209 183.274C172.209 183.274 173.82 183.544 174.478 183.678C174.478 183.678 173.572 183.975 174.959 188.17C176.346 192.364 177.603 195.198 175.461 197.651C173.319 200.105 170.936 204.188 170.936 204.188C170.936 204.188 174.884 204.697 167.89 214.223L167.898 209.665L172.209 183.274Z",
    fill: "url(#paint51_linear_6_376)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M159.201 181.107C159.499 181.119 163.626 181.149 163.626 181.149C163.626 181.149 164.493 185.612 163.99 186.737C163.99 186.737 160.436 182.68 158.516 182.264L159.201 181.107Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M166.019 181.297C166.019 181.297 166.113 184.353 166.835 186.42C166.835 186.42 168.38 183.962 169.056 183.238L168.805 181.724L166.019 181.297Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M166.686 174.401C168.2 172.976 168.408 172.809 168.579 172.305C169.269 170.299 167.764 167.5 165.717 166.778C165.611 166.74 164.241 166.27 163.703 166.858C163.245 167.357 163.889 168.07 163.556 169.043C163.245 169.953 162.449 170.006 160.952 171.177C159.719 172.141 158.954 172.74 158.762 173.602C158.367 175.379 160.474 178.008 162.387 177.976C163.075 177.969 163.269 177.622 166.686 174.401Z",
    fill: "url(#paint52_linear_6_376)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M162.569 178.26C162.569 178.26 164.107 180.075 166.519 179.541C168.679 179.058 168.232 174.115 166.675 173.296C166.156 173.022 165.202 173.024 164.479 173.355C164.05 173.551 163.929 173.76 163.223 174.065C162.573 174.347 162.37 174.298 162.193 174.507C161.97 174.762 161.865 175.322 162.517 176.683C162.035 176.326 161.51 176.243 161.182 176.465C161.072 176.551 160.987 176.664 160.936 176.794C160.715 177.395 161.341 178.029 162.569 178.26Z",
    fill: "url(#paint53_linear_6_376)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M128.826 242.336C128.826 242.336 129.028 243.966 128.256 244.548C127.484 245.13 125.983 247.297 126.782 248.833C127.581 250.37 129.577 250.541 131.324 250.246C131.324 250.246 129.892 247.801 130.413 247.335L132.083 248.127C132.007 247.589 131.797 247.079 131.47 246.645C130.943 245.976 130.485 244.537 130.896 243.098L128.826 242.336Z",
    fill: "url(#paint54_linear_6_376)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M143.392 183.741C143.392 183.741 134.557 183.212 132.642 188.902C132.45 189.472 122.884 225.899 128.27 243.069L131.384 243.836C131.384 243.836 136.885 218.579 145.741 202.947L143.392 183.741Z",
    fill: "url(#paint55_linear_6_376)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M243.687 207.438C244.495 210.517 245.542 214.061 246.677 218.051C250.499 231.489 264.118 246.062 264.118 246.062L266.331 243.839L267.472 242.692C267.472 242.692 263.762 230.421 261.225 226.983C258.689 223.545 257.284 216.945 255.925 205.769C254.566 194.593 244.07 193.777 244.07 193.777C241.22 195.492 241.771 200.151 243.687 207.438Z",
    fill: "url(#paint56_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M243.687 207.438C244.495 210.517 245.542 214.061 246.677 218.051C250.499 231.489 264.118 246.062 264.118 246.062L266.331 243.839C264.408 236.718 256.93 227.434 254.783 226.104C252.402 224.63 252.592 221.754 253.993 215.783C255.394 209.811 249.937 200.744 249.937 200.744L243.687 207.438Z",
    fill: "url(#paint57_linear_6_376)"
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M288.238 285.359C288.238 285.359 289.125 287.435 289.53 288.189C289.935 288.942 287.966 291.026 287.677 290.853C287.388 290.679 287.91 288.999 287.677 288.42C287.444 287.842 286.629 285.307 286.808 284.895C286.987 284.483 288.238 285.359 288.238 285.359Z",
    fill: "url(#paint58_linear_6_376)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M265.761 257.333C265.191 257.163 263.509 256.127 263.238 254.559C263.053 253.491 263.704 253.011 263.415 251.907C263.095 250.653 262.112 250.683 261.397 249.414C260.562 247.933 260.677 245.725 261.676 244.408C262.481 243.348 263.205 243.732 264.635 242.346C265.9 241.121 265.652 240.515 266.506 239.918C268.165 238.754 269.868 240.522 272.581 240.282C276.352 239.95 276.794 236.217 279.706 236.383C282.385 236.535 285.25 239.875 285.352 242.713C285.393 243.85 284.997 244.398 285.395 245.444C286.008 247.052 287.516 246.859 288.482 248.507C289.213 249.756 289.426 251.702 288.553 252.726C287.53 253.924 285.807 252.928 284.781 254.103C283.674 255.367 285.13 257.145 284.05 258.49C283.034 259.761 280.664 259.601 279.314 259.345C277.684 259.037 276.17 258.343 274.582 257.857C271.65 256.958 268.652 258.192 265.761 257.333Z",
    fill: "url(#paint59_linear_6_376)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M275.311 320.197C275.311 320.197 274.636 322.176 274.992 322.427C275.349 322.677 279.651 322.624 279.934 322.556C280.217 322.488 276.993 320.227 276.448 320.197C276.069 320.176 275.69 320.176 275.311 320.197Z",
    fill: "url(#paint60_linear_6_376)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M262.717 321.471C262.717 321.471 263.3 322.824 262.933 323.058C262.566 323.292 257.367 323.538 257.459 323.426C257.551 323.314 261.294 321.627 261.294 321.627L262.717 321.471Z",
    fill: "url(#paint61_linear_6_376)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M258.844 292.687C258.237 302.402 259.061 312.152 261.289 321.627L262.795 321.683C263.934 319.33 264.611 316.781 264.789 314.173C264.988 311.017 264.31 309.359 264.138 306.767C263.966 304.175 264.289 300.333 266.767 295.457L258.844 292.687Z",
    fill: "url(#paint62_linear_6_376)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M268.849 293.366C268.629 296.528 269.161 299.035 269.947 301.005C270.733 302.975 271.295 303.196 271.905 305.11C272.891 308.203 272.147 309.884 272.408 312.795C272.577 314.692 273.192 317.345 275.222 320.46L276.779 320.482C277.988 311.64 277.761 302.661 276.108 293.891L268.849 293.366Z",
    fill: "url(#paint63_linear_6_376)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M259.822 265.007C260.063 271.279 258.755 275.648 257.242 281.525C253.307 296.821 254.215 298.103 254.76 298.617C256.7 300.463 259.243 297.545 267.172 297.779C273.626 297.969 275.647 300.011 281.031 298.71C283.709 298.065 287.39 296.551 287.335 294.985C287.303 294.102 286.097 293.639 285.128 292.98C283.093 291.594 282.082 289.328 280.663 280.644C280.265 278.214 279.215 271.49 277.621 264.228C277.056 261.666 276.572 259.718 275.013 258.988C272.995 258.043 271.011 260.269 266.767 260.789C264.443 261.084 262.1 261.189 259.76 261.103C259.894 262.063 259.754 263.223 259.822 265.007Z",
    fill: "url(#paint64_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M281.981 296.994C279.103 296.011 278.928 294.038 275.869 291.839C269.046 286.932 262.208 291.202 259.798 287.707C257.079 283.759 264.922 277.024 262.206 270.068C261.683 268.766 260.877 267.596 259.847 266.642C259.823 272.07 258.617 276.173 257.239 281.525C253.304 296.821 254.211 298.103 254.756 298.617C256.696 300.463 259.24 297.545 267.168 297.779C273.623 297.969 275.643 300.011 281.027 298.71C282.312 298.402 283.564 297.968 284.763 297.412C283.818 297.436 282.877 297.295 281.981 296.994Z",
    fill: "url(#paint65_linear_6_376)"
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M259.756 261.106C259.756 261.106 248.025 264.912 239.989 258.079L237.873 260.494C237.873 260.494 247.491 275.352 262.115 266.997L259.756 261.106Z",
    fill: "url(#paint66_linear_6_376)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M265.487 256.174L265.179 258.378C265.101 258.938 264.858 259.462 264.482 259.884C264.105 260.305 263.612 260.606 263.064 260.746L261.207 261.223C261.207 261.223 267.776 263.9 272.27 259.269L270.291 259.335C269.636 259.358 268.993 259.154 268.471 258.758C267.949 258.362 267.579 257.798 267.425 257.162L267.204 256.259L265.487 256.174Z",
    fill: "url(#paint67_linear_6_376)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M268.284 257.148C268.284 257.148 265.64 258.378 263.488 256.465C261.564 254.756 264.919 249.406 266.991 249.312C267.683 249.281 268.658 249.794 269.204 250.555C269.528 251.006 269.53 251.309 270.074 252.033C270.576 252.701 270.81 252.759 270.873 253.087C270.951 253.495 270.732 254.183 269.263 255.379C269.962 255.235 270.556 255.423 270.762 255.852C270.827 256.012 270.848 256.186 270.822 256.357C270.691 257.163 269.68 257.547 268.284 257.148Z",
    fill: "url(#paint68_linear_6_376)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M239.989 258.083C239.989 258.083 239.691 255.295 236.156 256.174C232.622 257.053 235.392 256.512 236.538 258.168C237.684 259.823 237.873 260.496 237.873 260.496C237.873 260.496 240.49 259.255 239.989 258.083Z",
    fill: "url(#paint69_linear_6_376)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M289.128 285.219C289.128 285.219 286.53 261.517 275.008 258.992L273.171 269.55C273.171 269.55 282.543 273.508 286.339 285.219H289.128Z",
    fill: "url(#paint70_linear_6_376)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M236.548 178.196C236.548 178.196 242.655 180.71 240.949 185.199C239.242 189.689 241.442 192.316 239.467 193.044C237.492 193.773 226.89 195.705 227.074 193.277C227.258 190.85 229.542 190.109 229.588 187.854C229.633 185.599 232.013 176.76 236.548 178.196Z",
    fill: "url(#paint71_linear_6_376)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M233.138 320.232C233.138 320.232 232.915 321.997 233.064 322.589C233.213 323.18 238.346 323.606 240.088 323.404C241.83 323.201 239.05 321.424 237.94 321.086C236.831 320.747 233.138 320.232 233.138 320.232Z",
    fill: "url(#paint72_linear_6_376)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M235.721 317.288L235.18 320.828C235.18 320.828 233.8 321.449 233.138 320.836L233.064 317.129L235.721 317.288Z",
    fill: "url(#paint73_linear_6_376)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M246.47 251.939C247.023 257.374 247.089 262.848 246.667 268.296C245.968 277.346 244.155 283.073 241.885 292.722C240.497 298.618 238.624 307.298 236.937 318.153C236.021 318.681 234.956 318.89 233.909 318.748C233.258 318.65 232.637 318.414 232.086 318.055C227.648 304.497 228.958 296.094 231.1 290.86C232.013 288.629 233.12 286.868 233.712 283.438C234.494 278.898 233.527 276.363 232.145 265.851C231.162 258.358 231.33 257.201 231.987 256.078C234.598 251.585 242.602 251.673 246.47 251.939Z",
    fill: "url(#paint74_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M231.094 290.859C232.007 288.629 233.114 286.868 233.706 283.438C234.489 278.898 233.521 276.363 232.14 265.851C231.157 258.358 231.324 257.201 231.981 256.078C233.403 253.633 236.417 252.552 239.493 252.11C239.452 252.268 239.41 252.425 239.376 252.575C237.763 259.943 243.918 264.438 241.144 272.537C239.775 276.531 237.589 277.446 237.08 282.077C236.602 286.417 238.333 287.317 237.963 291.264C237.411 297.159 233.221 298.586 232.131 303.101C231.423 306.034 232.015 310.319 237.193 316.532C237.107 317.066 237.022 317.603 236.937 318.149C236.021 318.677 234.956 318.886 233.909 318.744C233.258 318.647 232.637 318.41 232.086 318.051C227.642 304.497 228.952 296.094 231.094 290.859Z",
    fill: "url(#paint75_linear_6_376)"
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M215.315 320.232C215.315 320.232 215.092 321.997 215.241 322.589C215.39 323.18 220.523 323.606 222.266 323.404C224.009 323.201 221.227 321.424 220.117 321.086C219.007 320.747 215.315 320.232 215.315 320.232Z",
    fill: "url(#paint76_linear_6_376)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M217.896 317.288L217.356 320.828C217.356 320.828 215.976 321.449 215.313 320.836L215.24 317.129L217.896 317.288Z",
    fill: "url(#paint77_linear_6_376)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M228.647 251.939C229.2 257.374 229.266 262.848 228.844 268.296C228.145 277.346 226.332 283.073 224.062 292.722C222.675 298.618 220.801 307.298 219.114 318.153C218.198 318.681 217.133 318.89 216.086 318.748C215.435 318.65 214.814 318.414 214.263 318.055C209.825 304.497 211.136 296.094 213.278 290.86C214.191 288.629 215.297 286.868 215.889 283.438C216.671 278.898 215.704 276.363 214.324 265.851C213.339 258.358 213.508 257.201 214.164 256.078C216.775 251.585 224.78 251.673 228.647 251.939Z",
    fill: "url(#paint78_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M213.272 290.859C214.185 288.629 215.291 286.868 215.883 283.438C216.665 278.898 215.698 276.363 214.318 265.851C213.334 258.358 213.502 257.201 214.158 256.078C215.581 253.633 218.594 252.552 221.67 252.11C221.629 252.268 221.588 252.425 221.553 252.575C219.939 259.943 226.095 264.438 223.32 272.537C221.95 276.531 219.766 277.446 219.256 282.077C218.779 286.417 220.509 287.317 220.139 291.264C219.587 297.159 215.398 298.586 214.308 303.101C213.6 306.034 214.192 310.319 219.37 316.532C219.284 317.066 219.197 317.603 219.112 318.149C218.197 318.677 217.132 318.886 216.084 318.744C215.434 318.646 214.813 318.41 214.262 318.051C209.819 304.497 211.13 296.094 213.272 290.859Z",
    fill: "url(#paint79_linear_6_376)"
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M193.051 297.084C193.513 297.577 194.039 298.008 194.614 298.364C200.703 302.207 214.552 301.19 226.22 296.719C228.329 295.911 230.021 295.481 231.422 295.297L233.361 292.409L233.936 295.233C238.584 295.67 239.325 299.226 246.94 295.164C257.481 289.536 249.523 248.282 248.529 237.928C247.534 227.574 249.275 222.981 249.275 222.981C258.39 209.031 247.702 194.565 247.702 194.565C234.688 187.114 226.191 193.376 220.533 197.549C219.361 198.415 218.52 199.655 218.149 201.064C217.779 202.473 217.901 203.966 218.496 205.296C219.67 207.918 221.386 211.753 223.644 216.799C228.372 227.383 219.394 237.22 212.45 241.084C205.505 244.948 209.695 260.805 202.51 265.83C195.324 270.855 200.236 280.317 196.762 287.037C193.288 293.757 188.141 291.804 193.051 297.084Z",
    fill: "url(#paint80_linear_6_376)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M244.619 212.652C244.619 212.652 232.158 196.391 225.081 194.606C226.852 193.86 228.689 193.283 230.568 192.883C236.195 191.69 240.738 192.341 243.653 192.958C244.32 195.106 246.94 204.173 244.619 212.652Z",
    fill: "url(#paint81_linear_6_376)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M233.735 184.91C233.735 184.91 233.078 190.16 231.139 191.364C229.2 192.568 226.066 194.138 225.721 194.565C225.377 194.992 237.731 196.32 243.854 193.229C241.836 192.809 241.292 192.654 241.292 192.654C240.389 192.42 239.518 192.076 238.699 191.629C237.564 190.972 236.591 190.072 235.848 188.993L235.871 186.082L233.735 184.91Z",
    fill: "url(#paint82_linear_6_376)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M231.872 185.571C232.016 185.262 232.57 185.105 233.198 185.303C232.37 183.174 233.924 181.32 234.499 180.977C235.314 180.489 236.528 180.404 237.178 180.661C239.136 181.433 240.496 187.88 237.993 188.742C235.198 189.701 233.472 187.236 233.472 187.236C233.037 187.16 232.638 186.949 232.329 186.634C232.213 186.51 231.691 185.962 231.872 185.571Z",
    fill: "url(#paint83_linear_6_376)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M193.051 297.084C193.513 297.577 194.039 298.008 194.614 298.364C199.337 296.223 202.823 286.965 207.633 278.403C213.955 267.151 207.78 262.123 217.598 257.679C227.417 253.234 231.967 250.391 229.119 245.123C226.27 239.854 228.257 227.647 234.795 227.165C241.333 226.683 246.091 221.659 245.562 216.75C245.032 211.842 234.123 213.4 233.046 208.967C231.968 204.535 224.032 197.622 224.032 197.622C222.67 196.15 220.692 197.389 218.381 200.355C218.068 201.145 217.918 201.989 217.938 202.838C217.958 203.687 218.148 204.523 218.497 205.297C219.671 207.919 221.387 211.754 223.645 216.8C228.373 227.384 219.395 237.221 212.451 241.085C205.506 244.949 209.697 260.806 202.511 265.831C195.325 270.856 200.238 280.318 196.764 287.038C193.29 293.759 188.141 291.804 193.051 297.084Z",
    fill: "url(#paint84_linear_6_376)"
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M228.314 198.707C232.17 200.383 238.008 197.576 243.385 197.972C246.921 198.23 247.381 197.3 246.966 195.905C246.754 195.179 246.301 194.32 245.918 193.443C245.132 191.632 242.747 191.331 240.299 191.25C240.285 191.25 240.27 191.25 240.259 191.25C240.241 191.249 240.223 191.249 240.206 191.25C240.426 190.76 240.755 190.335 240.947 189.822C241.133 189.319 241.272 188.8 241.365 188.272C241.567 187.181 241.604 186.06 241.679 184.958C241.765 183.678 241.795 182.397 241.439 181.159C241.135 180.085 240.682 178.849 239.778 178.132C239.24 177.724 238.61 177.453 237.943 177.344C228.302 175.947 228.957 186.499 228.233 188.733C227.51 190.967 223.964 192.647 222.76 194.372C221.556 196.096 224.457 197.032 228.314 198.707ZM237.555 179.627C240.434 180.071 240.388 184.487 240.029 186.601C239.882 187.454 239.691 188.298 239.456 189.13C239.408 189.302 238.98 190.975 238.809 191.192C238.802 191.201 238.794 191.208 238.785 191.214C238.783 191.215 238.781 191.215 238.779 191.215C238.778 191.215 238.776 191.215 238.774 191.214C238.269 191.207 237.78 191.194 237.311 191.173C234.143 191.008 233.199 190.167 231.981 187.195C231.825 186.791 231.717 186.37 231.66 185.94C231.66 185.933 231.66 185.928 231.66 185.921C231.616 185.601 231.598 185.278 231.604 184.955C231.669 181.996 234.505 179.157 237.555 179.627Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M233.209 193.574C236.02 193.632 235.253 191.816 238.258 194.117C241.264 196.417 243.881 194.446 246.45 195.756C246.608 195.845 246.785 195.896 246.966 195.905C246.754 195.179 246.301 194.32 245.918 193.443C245.132 191.632 242.747 191.331 240.299 191.25C240.285 191.25 240.27 191.25 240.259 191.25C240.227 191.25 240.209 191.209 240.209 191.209L238.812 191.115H238.798L238.785 191.164C238.785 191.164 238.774 191.193 238.771 191.193C238.266 191.186 237.775 191.186 237.307 191.165C234.138 191.001 233.195 190.166 231.976 187.194C231.82 186.791 231.712 186.371 231.655 185.942L231.646 185.927C231.646 185.927 230.393 193.512 233.209 193.574Z",
    fill: "url(#paint85_linear_6_376)"
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M207.157 257.954H208.733V255.964C208.734 255.653 208.847 255.353 209.053 255.12C209.258 254.886 209.541 254.736 209.849 254.696L216.727 253.8C216.908 253.777 217.091 253.792 217.265 253.845C217.439 253.899 217.6 253.988 217.737 254.108C217.874 254.228 217.983 254.376 218.058 254.542C218.133 254.708 218.172 254.887 218.172 255.069V256.901H219.749V255.069C219.75 254.663 219.663 254.262 219.496 253.891C219.328 253.521 219.084 253.191 218.779 252.923C218.473 252.655 218.114 252.455 217.726 252.337C217.337 252.218 216.928 252.184 216.525 252.237L209.645 253.132C208.958 253.223 208.327 253.56 207.869 254.081C207.411 254.601 207.158 255.27 207.157 255.964V257.954Z",
    fill: "url(#paint86_linear_6_376)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M232.9 257.202L224.525 255.689L225.285 288.871L231.468 287.858C231.735 287.814 231.979 287.68 232.159 287.478C232.339 287.276 232.445 287.019 232.459 286.748L233.871 258.433C233.887 258.145 233.797 257.861 233.619 257.634C233.44 257.407 233.184 257.254 232.9 257.202Z",
    fill: "url(#paint87_linear_6_376)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M198.098 257.937L224.527 255.684L225.286 288.866L199.938 285.413C199.546 285.359 199.184 285.173 198.911 284.885C198.639 284.598 198.474 284.226 198.442 283.831L196.513 259.807C196.476 259.349 196.622 258.895 196.919 258.545C197.216 258.194 197.64 257.976 198.098 257.937Z",
    fill: "url(#paint88_linear_6_376)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M228.943 256.485L229.728 256.627C229.593 262.534 229.164 281.31 229.018 288.253L228.228 288.382C228.371 281.49 228.809 262.341 228.943 256.485Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M213.689 247.676C213.689 247.676 213.615 250.027 214.021 250.544C214.426 251.061 215.344 251.941 214.941 252.443C214.538 252.945 215.743 255.038 213.684 255.684C211.625 256.33 210.408 255.151 210.444 253.677C210.48 252.203 211.089 249.695 210.896 248.073C210.703 246.451 213.026 246.689 213.689 247.676Z",
    fill: "url(#paint89_linear_6_376)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M222.521 196.75C222.521 196.75 230.475 203.037 225.53 212.652C220.586 222.267 218.143 228.273 218.31 232.37C218.476 236.468 214.832 248.226 214.832 248.226L210.334 249.111C210.334 249.111 207.306 230.207 211.506 217.464C215.707 204.721 217.97 196.517 222.521 196.75Z",
    fill: "url(#paint90_linear_6_376)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M193.018 60.8537C195.146 58.5753 197.72 56.7588 200.58 55.517C203.44 54.2752 206.525 53.6346 209.643 53.6351H213.302C213.819 53.6349 214.327 53.7661 214.778 54.0163C215.23 54.2665 215.611 54.6276 215.884 55.0655C216.158 55.5034 216.316 56.0037 216.343 56.5193C216.369 57.035 216.265 57.5489 216.038 58.0128L198.331 94.2792H161.814L193.018 60.8537Z",
    fill: "url(#paint91_linear_6_376)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M122.785 102.293C125.037 97.7961 128.497 94.0146 132.777 91.3719C137.057 88.7292 141.988 87.3295 147.019 87.3296H215.478C217.717 87.3294 219.915 86.7212 221.836 85.5698C223.757 84.4184 225.33 82.7671 226.385 80.7921L233.722 67.0535C234.181 66.1949 234.865 65.477 235.701 64.9765C236.536 64.476 237.492 64.2116 238.466 64.2115H245.711C245.859 64.2114 246.005 64.2491 246.135 64.3212C246.265 64.3932 246.374 64.4972 246.452 64.6232C246.53 64.7492 246.575 64.8931 246.583 65.0413C246.59 65.1895 246.559 65.3371 246.493 65.4701L229.533 99.8701C228.365 102.239 226.557 104.234 224.313 105.628C222.07 107.023 219.481 107.763 216.839 107.763H126.164C125.52 107.763 124.886 107.598 124.323 107.284C123.761 106.971 123.287 106.518 122.949 105.97C122.61 105.422 122.417 104.797 122.389 104.153C122.36 103.509 122.496 102.869 122.785 102.293Z",
    fill: "url(#paint92_linear_6_376)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 96.56H196.242C196.869 96.5599 197.484 96.736 198.016 97.0683C198.547 97.4006 198.975 97.8756 199.25 98.4392L215.089 130.894C215.415 131.563 215.566 132.304 215.527 133.048C215.488 133.791 215.261 134.512 214.866 135.144C214.472 135.775 213.923 136.296 213.272 136.657C212.62 137.018 211.888 137.208 211.143 137.208H209.638C206.52 137.208 203.435 136.568 200.575 135.326C197.716 134.084 195.142 132.267 193.014 129.989L167.069 102.189C165.073 100.051 166.589 96.56 169.516 96.56Z",
    fill: "url(#paint93_linear_6_376)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M141.34 98.6313H125.001C127.51 95.1349 130.815 92.2861 134.644 90.3207C138.473 88.3554 142.715 87.3301 147.019 87.3296H151.504L146.972 95.348C146.409 96.3449 145.59 97.1742 144.601 97.7511C143.611 98.328 142.486 98.6317 141.34 98.6313Z",
    fill: "url(#paint94_linear_6_376)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M105.353 57.7951C105.353 64.4863 95.9758 76.6985 91.7273 81.8819C91.4796 82.1842 91.1678 82.4278 90.8144 82.5951C90.4611 82.7624 90.075 82.8492 89.684 82.8492C89.2931 82.8492 88.907 82.7624 88.5536 82.5951C88.2003 82.4278 87.8885 82.1842 87.6407 81.8819C83.3969 76.6985 74.0149 64.4863 74.0149 57.7951C73.9896 55.7226 74.3761 53.6657 75.152 51.7436C75.9278 49.8215 77.0776 48.0725 78.5346 46.598C79.9916 45.1235 81.727 43.9528 83.6399 43.1538C85.5529 42.3548 87.6055 41.9434 89.6788 41.9434C91.752 41.9434 93.8046 42.3548 95.7176 43.1538C97.6306 43.9528 99.3659 45.1235 100.823 46.598C102.28 48.0725 103.43 49.8215 104.206 51.7436C104.981 53.6657 105.368 55.7226 105.343 57.7951H105.353Z",
    fill: "url(#paint95_linear_6_376)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6881 66.5296C94.5133 66.5296 98.4249 62.6191 98.4249 57.7951C98.4249 52.9712 94.5133 49.0607 89.6881 49.0607C84.8629 49.0607 80.9513 52.9712 80.9513 57.7951C80.9513 62.6191 84.8629 66.5296 89.6881 66.5296Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M89.6194 75.4515C90.6128 68.9082 94.9346 66.8137 94.1928 60.636C93.3379 53.5105 87.027 51.6128 86.8744 45.2674C86.8537 44.2711 86.9808 43.2773 87.2518 42.3183C83.5642 42.8997 80.2055 44.7783 77.7804 47.6157C75.3553 50.4532 74.0233 54.063 74.0242 57.7951C74.0242 64.4863 83.4016 76.6985 87.65 81.8819C87.941 82.2369 88.3198 82.5096 88.7489 82.673C89.1779 82.8364 89.6422 82.8848 90.0957 82.8133C89.3306 79.9526 89.3073 77.5053 89.6194 75.4515Z",
    fill: "url(#paint96_linear_6_376)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8519 90.0183C93.1352 88.2734 91.95 86.6294 90.2047 86.3462C88.4594 86.0629 86.815 87.2478 86.5317 88.9926C86.2484 90.7374 87.4335 92.3815 89.1788 92.6647C90.9241 92.9479 92.5686 91.7631 92.8519 90.0183Z",
    fill: "url(#paint97_linear_6_376)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M271.182 112.354C271.182 119.58 261.057 132.766 256.474 138.363C256.206 138.689 255.87 138.952 255.488 139.133C255.107 139.314 254.69 139.408 254.267 139.408C253.845 139.408 253.428 139.314 253.047 139.133C252.665 138.952 252.329 138.689 252.061 138.363C247.478 132.766 237.352 119.58 237.352 112.354C237.352 107.869 239.134 103.568 242.306 100.396C245.479 97.2251 249.781 95.4435 254.267 95.4435C258.753 95.4435 263.055 97.2251 266.227 100.396C269.399 103.568 271.182 107.869 271.182 112.354Z",
    fill: "url(#paint98_linear_6_376)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M263.887 113.104C264.721 107.948 261.216 103.092 256.058 102.259C250.9 101.425 246.043 104.93 245.21 110.086C244.376 115.243 247.881 120.098 253.039 120.932C258.197 121.765 263.054 118.26 263.887 113.104Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M254.192 131.422C255.266 124.357 259.933 122.095 259.131 115.424C258.208 107.73 251.394 105.681 251.228 98.8327C251.207 97.7575 251.344 96.6849 251.635 95.6496C247.655 96.2774 244.029 98.3048 241.411 101.367C238.792 104.429 237.353 108.325 237.352 112.354C237.352 119.58 247.484 132.766 252.061 138.363C252.374 138.747 252.783 139.043 253.246 139.22C253.709 139.398 254.21 139.451 254.7 139.374C253.883 136.282 253.856 133.639 254.192 131.422Z",
    fill: "url(#paint99_linear_6_376)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M255.897 149.666C257.581 148.766 258.215 146.671 257.314 144.988C256.414 143.304 254.318 142.67 252.634 143.571C250.951 144.471 250.316 146.566 251.217 148.249C252.118 149.933 254.213 150.567 255.897 149.666Z",
    fill: "url(#paint100_linear_6_376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_376",
    x1: 60.2126,
    y1: 42.7338,
    x2: 61.9159,
    y2: 237.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_376",
    x1: 0.525761,
    y1: 126.077,
    x2: 227.549,
    y2: 374.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_376",
    x1: 321.649,
    y1: 101.108,
    x2: 146.173,
    y2: 391.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA80F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_376",
    x1: 197.933,
    y1: 229.353,
    x2: 109.012,
    y2: 15.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_376",
    x1: 38.6495,
    y1: 149.386,
    x2: 290.425,
    y2: 149.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD53B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_376",
    x1: 66.0991,
    y1: 240.951,
    x2: 113.284,
    y2: 240.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_376",
    x1: 241.251,
    y1: 244.053,
    x2: 284.983,
    y2: 244.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_376",
    x1: 63.0269,
    y1: 193.709,
    x2: 62.2936,
    y2: 217.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_376",
    x1: 37.5013,
    y1: 283.908,
    x2: 32.1255,
    y2: 283.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_376",
    x1: 41.2396,
    y1: 279.576,
    x2: 35.0463,
    y2: 279.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_376",
    x1: 111.26,
    y1: 322.797,
    x2: 105.304,
    y2: 304.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_376",
    x1: 101.487,
    y1: 277.258,
    x2: 75.4777,
    y2: 277.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6_376",
    x1: 83.2448,
    y1: 268.951,
    x2: 38.3825,
    y2: 263.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6_376",
    x1: 117.664,
    y1: 142.074,
    x2: 118.983,
    y2: 160.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FBAB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6_376",
    x1: 104.451,
    y1: 183.602,
    x2: 102.701,
    y2: 243.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6_376",
    x1: 104.428,
    y1: 195.229,
    x2: 108.585,
    y2: 221.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6_376",
    x1: 71.0953,
    y1: 182.626,
    x2: 69.3458,
    y2: 242.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6_376",
    x1: 69.0444,
    y1: 194.494,
    x2: 59.4962,
    y2: 252.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6_376",
    x1: 84.9214,
    y1: 196.585,
    x2: 74.7151,
    y2: 181.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6_376",
    x1: 85.8473,
    y1: 189.07,
    x2: 69.7106,
    y2: 179.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6_376",
    x1: 79.1718,
    y1: 214.969,
    x2: 77.4033,
    y2: 217.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6_376",
    x1: 68.6916,
    y1: 182.555,
    x2: 66.9421,
    y2: 242.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6_376",
    x1: 129.889,
    y1: 324.966,
    x2: 134.096,
    y2: 285.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6_376",
    x1: 136.536,
    y1: 291.141,
    x2: 129.158,
    y2: 312.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6_376",
    x1: 132.565,
    y1: 268.394,
    x2: 174.609,
    y2: 268.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6_376",
    x1: 132.565,
    y1: 268.394,
    x2: 174.609,
    y2: 268.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6_376",
    x1: 194.287,
    y1: 254.304,
    x2: 194.271,
    y2: 224.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6_376",
    x1: 170.511,
    y1: 215.324,
    x2: 194.871,
    y2: 215.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6_376",
    x1: 177.619,
    y1: 305.586,
    x2: 170.242,
    y2: 326.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6_376",
    x1: 175.935,
    y1: 329.871,
    x2: 180.142,
    y2: 290.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6_376",
    x1: 161.03,
    y1: 249.604,
    x2: 163.579,
    y2: 198.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6_376",
    x1: 122.341,
    y1: 259.949,
    x2: 125.766,
    y2: 245.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6_376",
    x1: 128.793,
    y1: 256.31,
    x2: 131.183,
    y2: 245.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6_376",
    x1: 134.512,
    y1: 250.084,
    x2: 125.731,
    y2: 251.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6_376",
    x1: 132.38,
    y1: 264.86,
    x2: 136.263,
    y2: 247.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6_376",
    x1: 140.76,
    y1: 265.865,
    x2: 156.865,
    y2: 228.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6_376",
    x1: 117.239,
    y1: 276.693,
    x2: 150.308,
    y2: 269.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6_376",
    x1: 149.463,
    y1: 262.353,
    x2: 136.5,
    y2: 274.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6_376",
    x1: 133.428,
    y1: 238.626,
    x2: 117.486,
    y2: 280.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6_376",
    x1: 131.459,
    y1: 264.25,
    x2: 103.22,
    y2: 274.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6_376",
    x1: 137.914,
    y1: 263.426,
    x2: 128.64,
    y2: 260.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6_376",
    x1: 113.249,
    y1: 291.84,
    x2: 128.173,
    y2: 254.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6_376",
    x1: 108.941,
    y1: 300.136,
    x2: 130.574,
    y2: 249.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6_376",
    x1: 109.757,
    y1: 270.05,
    x2: 129.489,
    y2: 266.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6_376",
    x1: 127.293,
    y1: 267.123,
    x2: 108.096,
    y2: 268.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6_376",
    x1: 142.769,
    y1: 230.697,
    x2: 210.213,
    y2: 143.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6_376",
    x1: 167.847,
    y1: 213.758,
    x2: 179.903,
    y2: 213.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6_376",
    x1: 163.324,
    y1: 185.673,
    x2: 164.12,
    y2: 179.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6_376",
    x1: 164.725,
    y1: 198.25,
    x2: 169.685,
    y2: 198.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6_376",
    x1: 163.37,
    y1: 184.455,
    x2: 166.318,
    y2: 184.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6_376",
    x1: 176.643,
    y1: 180.827,
    x2: 156.531,
    y2: 201.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6165D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA80F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6_376",
    x1: 164.295,
    y1: 190.87,
    x2: 172.905,
    y2: 200.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6165D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9E7BF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6_376",
    x1: 159.487,
    y1: 186.835,
    x2: 165.551,
    y2: 168.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6_376",
    x1: 173.102,
    y1: 179.628,
    x2: 157.293,
    y2: 172.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6_376",
    x1: 129.311,
    y1: 254.338,
    x2: 129.296,
    y2: 224.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6_376",
    x1: 128.944,
    y1: 220.065,
    x2: 196.388,
    y2: 132.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6_376",
    x1: 242.091,
    y1: 219.921,
    x2: 267.469,
    y2: 219.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDC838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6_376",
    x1: 243.687,
    y1: 223.403,
    x2: 266.327,
    y2: 223.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6_376",
    x1: 288.444,
    y1: 285.321,
    x2: 286.569,
    y2: 295.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6_376",
    x1: 263.517,
    y1: 238.369,
    x2: 283.651,
    y2: 256.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6_376",
    x1: 278.062,
    y1: 314.777,
    x2: 276.726,
    y2: 330.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6_376",
    x1: 261.101,
    y1: 313.313,
    x2: 259.765,
    y2: 328.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6_376",
    x1: 258.653,
    y1: 307.185,
    x2: 266.771,
    y2: 307.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6_376",
    x1: 268.799,
    y1: 306.924,
    x2: 277.543,
    y2: 306.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6_376",
    x1: 274.955,
    y1: 270.225,
    x2: 264.385,
    y2: 329.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6_376",
    x1: 265.796,
    y1: 290.843,
    x2: 280.882,
    y2: 270.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6_376",
    x1: 249.646,
    y1: 265.698,
    x2: 239.076,
    y2: 324.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6_376",
    x1: 266.388,
    y1: 254.024,
    x2: 266.961,
    y2: 264.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6_376",
    x1: 245.697,
    y1: 251.721,
    x2: 260.694,
    y2: 252.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_6_376",
    x1: 235.085,
    y1: 260.635,
    x2: 239.312,
    y2: 254.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_6_376",
    x1: 282.174,
    y1: 271.516,
    x2: 271.604,
    y2: 330.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_6_376",
    x1: 236.481,
    y1: 175.568,
    x2: 233.897,
    y2: 191.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_6_376",
    x1: 237.582,
    y1: 308.879,
    x2: 235.809,
    y2: 340.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_6_376",
    x1: 234.231,
    y1: 324.613,
    x2: 235.173,
    y2: 281.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_6_376",
    x1: 247.92,
    y1: 296.597,
    x2: 230.02,
    y2: 272.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_6_376",
    x1: 245.636,
    y1: 298.298,
    x2: 227.735,
    y2: 274.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_6_376",
    x1: 219.759,
    y1: 308.879,
    x2: 217.986,
    y2: 340.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_6_376",
    x1: 216.408,
    y1: 324.613,
    x2: 217.35,
    y2: 281.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_6_376",
    x1: 230.098,
    y1: 296.597,
    x2: 212.197,
    y2: 272.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_6_376",
    x1: 227.813,
    y1: 298.298,
    x2: 209.914,
    y2: 274.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_6_376",
    x1: 191.03,
    y1: 245.915,
    x2: 252.954,
    y2: 245.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_6_376",
    x1: -201.578,
    y1: 1442.45,
    x2: -186.507,
    y2: 1399.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_6_376",
    x1: 235.455,
    y1: 194.879,
    x2: 222.908,
    y2: 176.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_6_376",
    x1: 237.954,
    y1: 185.934,
    x2: 210.484,
    y2: 168.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_6_376",
    x1: 191.03,
    y1: 247.676,
    x2: 245.602,
    y2: 247.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EED03E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD53B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_6_376",
    x1: 234.686,
    y1: 194.284,
    x2: 236.317,
    y2: 192.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_6_376",
    x1: 216.061,
    y1: 203.477,
    x2: 213.106,
    y2: 263.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_6_376",
    x1: 233.872,
    y1: 272.274,
    x2: 224.525,
    y2: 272.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_6_376",
    x1: 275.989,
    y1: 202.998,
    x2: 198.193,
    y2: 287.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_6_376",
    x1: 209.704,
    y1: 248.946,
    x2: 220.714,
    y2: 259.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_6_376",
    x1: 209.281,
    y1: 222.926,
    x2: 227.15,
    y2: 222.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDC838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_6_376",
    x1: 161.814,
    y1: 73.9554,
    x2: 216.351,
    y2: 73.9554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_6_376",
    x1: 122.381,
    y1: 85.986,
    x2: 246.59,
    y2: 85.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_6_376",
    x1: 166.163,
    y1: 116.884,
    x2: 215.544,
    y2: 116.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_6_376",
    x1: 135.573,
    y1: 87.1398,
    x2: 143.644,
    y2: 104.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_6_376",
    x1: 87.6675,
    y1: 52.1088,
    x2: 103.436,
    y2: 92.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_6_376",
    x1: 82.0192,
    y1: 54.3011,
    x2: 97.7875,
    y2: 94.9271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_6_376",
    x1: 93.801,
    y1: 83.2706,
    x2: 83.5587,
    y2: 98.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD53B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_6_376",
    x1: 252.084,
    y1: 106.217,
    x2: 269.111,
    y2: 150.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_6_376",
    x1: 245.985,
    y1: 108.584,
    x2: 263.012,
    y2: 152.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_6_376",
    x1: 258.711,
    y1: 139.868,
    x2: 247.652,
    y2: 156.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDC838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroOne);
export default __webpack_public_path__ + "static/media/introOne.1ec319040e5d3c98b65a2b28a846868f.svg";
export { ForwardRef as ReactComponent };